import request from '@/utils/request'

/**
 * 分页查询系统操作日志
 * @param {Object} params 查询参数
 * @param {number} params.pageNum 当前页
 * @param {number} params.pageSize 每页大小
 * @param {string} params.module 模块（可选）
 * @param {number} params.userId 用户ID（可选）
 * @param {string} params.userName 用户名（可选）
 * @param {string} params.operateDesc 操作描述（可选）
 * @param {string} params.source 来源（可选）
 * @param {number} params.status 状态（可选，0-成功 1-异常）
 */
export function reqSysOperationLogPage(params) {
    return request({
        url: '/system/sysOperationLog/page',
        method: 'get',
        params
    })
}
